@use "@fukuri-admins/ui/layout" as *;

.statusCol {
  width: 100px;
}

.targetUserCountCol {
  width: 120px;
  text-align: right;
}

.deliverAtCol {
  @include colDateTime;
}
